export default "__VITE_ASSET__abc29d7b__"